export { DialogStudentDelete } from './dialog-student-delete';
